<template>
  <div class="space-y-6" data-testid="impact-data-basis">
    <div>
      <p class="text-[13px] text-[#ABABAB] uppercase tracking-wider font-medium mb-3 m-0">
        {{ $t('UserProjects.impactAnalysis.dataBasis.nValues') }}
      </p>
      <div class="overflow-x-auto">
        <table class="w-full text-[13px]">
          <thead>
            <tr class="border-b border-[#E5E5E5]">
              <th class="text-left py-2 px-3 font-medium text-[var(--color-disabled)]">
                {{ $t('UserProjects.impactAnalysis.dataBasis.metric') }}
              </th>
              <th class="text-left py-2 px-3 font-medium text-[var(--color-disabled)]">
                {{ $t('UserProjects.impactAnalysis.dataBasis.value') }}
              </th>
              <th class="text-left py-2 px-3 font-medium text-[var(--color-disabled)]">
                {{ $t('UserProjects.impactAnalysis.dataBasis.basis') }}
              </th>
              <th class="text-left py-2 px-3 font-medium text-[var(--color-disabled)]">
                {{ $t('UserProjects.impactAnalysis.dataBasis.period') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in rows"
              :key="row.label"
              class="border-b border-[#F0F0F0]"
              :style="{ color: row.lowData ? '#ABABAB' : undefined }"
            >
              <td class="py-2.5 px-3 text-[var(--color-dark)]">{{ row.label }}</td>
              <td class="py-2.5 px-3 font-medium">{{ row.value }}</td>
              <td class="py-2.5 px-3 text-[var(--color-disabled)]">
                n={{ row.n }}
                <span v-if="row.lowData" class="ml-2 text-[var(--color-error,#EF4444)]">n &lt; 5</span>
              </td>
              <td class="py-2.5 px-3 text-[var(--color-disabled)]">{{ row.period }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ImpactComingSoonPanel
      :title="$t('UserProjects.impactAnalysis.comingSoon.affectedTeamsTitle')"
      :message="$t('UserProjects.impactAnalysis.comingSoon.affectedTeams')"
      test-id="impact-coming-soon-data-teams"
    />
  </div>
</template>

<script>
import ImpactComingSoonPanel from './ImpactComingSoonPanel.vue';

export default {
  name: 'ImpactDataBasisPanel',
  components: { ImpactComingSoonPanel },
  props: {
    dataBasis: { type: Object, default: null },
  },
  computed: {
    rows() {
      const basis = this.dataBasis || {};
      return [
        {
          label: 'PPC',
          value: basis.ppcValue != null ? `${basis.ppcValue}%` : '—',
          n: basis.ppcCommitmentsN ?? 0,
          period: basis.periodLabel || '—',
          lowData: (basis.ppcCommitmentsN ?? 0) < 5,
        },
        {
          label: 'TBI',
          value: basis.tbiValue != null ? String(basis.tbiValue) : '—',
          n: basis.reflectionsN ?? 0,
          period: basis.periodLabel || '—',
          lowData: (basis.reflectionsN ?? 0) < 5,
        },
        {
          label: this.$t('UserProjects.impactAnalysis.dataBasis.breaks'),
          value: String(basis.commitmentBreaksN ?? 0),
          n: basis.commitmentBreaksN ?? 0,
          period: basis.periodLabel || '—',
          lowData: false,
        },
        {
          label: this.$t('UserProjects.impactAnalysis.dataBasis.avgPpc'),
          value: basis.avgPpc8Weeks != null ? `${basis.avgPpc8Weeks}%` : '—',
          n: basis.ppcCommitmentsN ?? 0,
          period: basis.periodLabel || '—',
          lowData: false,
        },
      ];
    },
  },
};
</script>
